/* eslint-disable */
import Vue from 'vue'
import VueQriously from 'vue-qriously'
import VueClipboard from 'vue-clipboard2'
import Vuesax from 'vuesax'
import VueQrcodeReader from 'vue-qrcode-reader'
import VueYoutube from 'vue-youtube'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en' // lang i18n

//import VueToast from 'vue-toast-notification';

//import 'vue-toast-notification/dist/theme-sugar.css';

import '@/styles/index.scss' // global css
import 'material-icons/iconfont/material-icons.css'
import '@/assets/fonts/docutag/css/docutag.css'
import 'vuesax/dist/vuesax.css'

import App from './App'
import router from './router'
import store from './store'
import { siteKey } from '@/plugins/vue-recaptcha-v3/config.js'
import MIcon from '@/components/Icon/MIcon.vue'

import '@/icons' // icon
import '@/permission' // permission control

Sentry.init({
  dsn: 'https://79316ffb4d164fb5a6aaaf3a59278d58@sentry.luxtag.io/4',
  integrations: [new Integrations.Vue({ Vue, attachProps: true })],
  environment: process.env.NODE_ENV
})

Vue.use(ElementUI, { locale })
Vue.use(VueQriously)
Vue.use(VueClipboard)
Vue.use(VueYoutube)
Vue.use(VueReCaptcha, {
  siteKey: siteKey
})
//Vue.use(VueToast);


Vue.component('m-icon', MIcon)

Vue.prototype.$NETWORK_ID = process.env.NETWORK_ID

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})

Vue.use(VueQrcodeReader)

Vue.use(Vuesax, {
  theme: {
    colors: {
      primary: '#023373'
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js